import axios from 'axios';
import { TokenUtils } from '@/utils/TokenUtils';

const baseUrl = `${process.env.VUE_APP_BASEURL}`;
const baseUrlCitCfdi = `${process.env.VUE_APP_BASEURL_CITCFDI}`;
const citCfdiApiKey = process.env.VUE_APP_CITCFDI_APIKEY;

export default axios.create({
  baseURL: baseUrl,
  headers: { 'Content-Type': 'application/json' },
});

export const CitCfdiAxios = axios.create({
  baseURL: baseUrlCitCfdi,
  headers: { 'Content-Type': 'application/json', 'X-API-KEY': citCfdiApiKey },
});

export function setAuthHeaders(headers) {
  return {
    ...headers,
    Authorization: `Bearer ${TokenUtils.getToken()}`,
  };
}
